import { Collapse } from 'bootstrap';

// When a collapse toggle with [data-wf-collapse-toggle-prevent-close="true"] is clicked
// and its target is already open, prevent Bootstrap from closing it.
//
// Bootstrap listens for clicks in capture phase on document, so it fires toggle() before
// any button-level listener can set a flag. Instead, we patch Collapse.prototype.toggle to
// short-circuit for protected collapse elements that are already shown.
// Accordion hides (called via hide() directly, not toggle()) are unaffected.
function initCollapsePreventClose() {
  const protectedCollapses = new Set<Element>();

  document.querySelectorAll<HTMLElement>('[data-wf-collapse-toggle-prevent-close="true"]').forEach(btn => {
    const targetSel = btn.getAttribute('data-bs-target') || btn.getAttribute('href');
    if (targetSel) {
      const target = document.querySelector(targetSel);
      if (target) protectedCollapses.add(target);
    }
  });

  if (protectedCollapses.size > 0) {
    const origToggle = Collapse.prototype.toggle;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Collapse.prototype.toggle = function (this: any) {
      if (protectedCollapses.has(this._element) && this._element.classList.contains('show')) {
        return;
      }
      return origToggle.call(this);
    };
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollapsePreventClose);
} else {
  initCollapsePreventClose();
}
